import React from 'react'
import { Row } from '@fs/zion-ui'
import { SocialConnect } from '@fs/zion-social'
import { useFeatureFlag } from '@fs/zion-flags'
import LanguageLink from '../../components/LanguageLink'

export default function FooterSocial({ centered = false }) {
  const showLangPicker = useFeatureFlag('home_footer_showLangPicker').isOn

  const platforms = {
    facebook: 'https://www.facebook.com/familysearch',
    twitter: 'https://www.twitter.com/familysearch',
    instagram: 'https://www.instagram.com/familysearch',
    youtube: 'https://www.youtube.com/familysearch',
  }
  const analytics = {
    link_page: 'fatfooter',
    link_app: 'home',
  }

  return (
    <>
      <SocialConnect
        platforms={platforms}
        useIconButtons
        alignX={centered ? 'center' : 'end'}
        iconButtonEmphasis="low"
        analytics={analytics}
        color="gray"
      />
      {showLangPicker && (
        <Row alignX={centered ? 'center' : 'end'}>
          <LanguageLink />
        </Row>
      )}
    </>
  )
}
